import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

// The product is Studium. `shaamos` below is not the brand — it is the live
// Firebase/GCP project id, and the auth and storage hosts derived from it.
// Renaming it means creating a new project and migrating every account,
// document, stored object and KMS key. It is deliberately left alone.
const firebaseConfig = {
  apiKey: 'AIzaSyDP1favpnaTCfYMRy60CevmRO4JOs2b1jY',
  authDomain: 'shaamos.firebaseapp.com',
  projectId: 'shaamos',
  storageBucket: 'shaamos.firebasestorage.app',
  messagingSenderId: '706056813600',
  appId: '1:706056813600:web:d9bdc43246ac5d2bc7d045',
  measurementId: 'G-M3DZH7NLJH',
};

// A reCAPTCHA Enterprise site key is public by design. It attests the browser
// origin; it is not an authorization credential and cannot access Firebase alone.
const appCheckSiteKey = '6LcEc34tAAAAAAmOQZ0wKdQM8dg9JfRoQmZaTRZW';

const app = initializeApp(firebaseConfig);

if (typeof window !== 'undefined' && !['localhost', '127.0.0.1'].includes(window.location.hostname)) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);
export const functions = getFunctions(app, 'me-west1');
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
